import UnionSquareProject from '../assets/union-square/union-square-project.jpg';
import UnionSquareProject_sm from '../assets/union-square/union-square-project-sm.jpg';

const getImage = (folder, filename, r) => {
  return [
    {
      srcSet: require(`../assets/${folder}/${filename}-thumb-${r}.jpg`),
      media: '(max-width: 100px)',
    },
    {
      srcSet: require(`../assets/${folder}/${filename}-sm-${r}.jpg`),
      media: '(max-width: 720px)',
    },
    {
      srcSet: require(`../assets/${folder}/${filename}-${r}.jpg`),
    },
  ];
};

const getImageSequence = (folder, filename, start, end) => {
  let imgs = [];
  for (let i = start; i <= end; i++) {
    // note: we add a key prop here to allow react to uniquely identify each
    // element in this array. see: https://reactjs.org/docs/lists-and-keys.html
    imgs.push(getImage(folder, filename, i));
  }
  return imgs;
};

const randomCommunityGardensIndex = 7;
const randomCommunityGardensImage = getImage(
  'community-gardens',
  'community-gardens',
  randomCommunityGardensIndex
);
const communityGardenImages = getImageSequence(
  'community-gardens',
  'community-gardens',
  3,
  20
);

const randomBlomImage = getImage(
  'blom',
  'blom-a-generative-art-series-by-lucastswick',
  1
);
const blomImages = getImageSequence(
  'blom',
  'blom-a-generative-art-series-by-lucastswick',
  1,
  941
);

const randomBlomArchiveIndex = Math.floor(Math.random() * 68 + 1);
const randomBlomArchiveImage = getImage(
  'blom-archive',
  'blom-a-generative-art-series-by-lucastswick',
  randomBlomArchiveIndex
);
const blomArchiveImages = getImageSequence(
  'blom-archive',
  'blom-a-generative-art-series-by-lucastswick',
  1,
  94
);

const randomLightbladeIndex = Math.floor(Math.random() * 9 + 1);
const randomLightbladeImage = getImage(
  'lightblades',
  'lightblades-installation-by-lucastswick-header',
  randomLightbladeIndex
);
const lightbladeImages = getImageSequence(
  'lightblades',
  'lightblades-installation-by-lucastswick',
  1,
  22
);

// const randomIntergalacticIndex = Math.floor(Math.random() * 27 + 1);
const randomIntergalacticImage = getImage(
  'intergalactic',
  'Intergalactic-a-collaboration-with-wendi-y-anderson-crop',
  24
);
const intergalacticImages = getImageSequence(
  'intergalactic',
  'Intergalactic-a-collaboration-with-wendi-y-anderson',
  1,
  27
);

const randomSketchIndex = Math.floor(Math.random() * 6 + 1);
const randomSketchImage = getImage(
  'sketches',
  'sketches-by-lucastswick',
  randomSketchIndex
);
const sketchImages = getImageSequence(
  'sketches',
  'sketches-by-lucastswick',
  1,
  14
);

const work = {
  blom: {
    title: 'Blóm',
    uid: 'blom',
    slug: 'blom-a-generative-art-series',
    link: '/work/blom-a-generative-art-series',
    excerpt:
      'I wrote an algorithm that draws abstract roses. It made thousands and thousands of images.',
    cta: 'Check out my favorites',
    // colorTheme: { base: '#121212', hilite: '#df0000' },
    headerImage: randomBlomImage,
    images: blomImages,
    prevSlug: 'community-gardens',
    nextSlug: 'unionSquare',
  },
  communityGardens: {
    title: 'Community Gardens',
    uid: 'community-gardens',
    slug:
      'community-gardens-a-data-driven-generative-art-installation-about-housing-insecurity-at-ncsu',
    link:
      '/work/community-gardens-a-data-driven-generative-art-installation-about-housing-insecurity-at-ncsu',
    excerpt:
      'Community Gardens is a data-driven generative art installation about food and housing insecurity within the student body at NCSU.',
    cta: 'Take a look',
    // colorTheme: { base: '#121212', hilite: '#df0000' },
    headerImage: randomCommunityGardensImage,
    images: communityGardenImages,
    prevSlug: 'sketches',
    nextSlug: 'blom',
  },
  blomArchive: {
    hidden: true,
    title: 'Blóm',
    uid: 'blom-archive',
    slug: 'blom-archive-generative-art-series',
    link: '/archive/blom-a-generative-art-series',
    excerpt:
      'In 2015, I wrote an algorithm that draws abstract roses. It made thousands and thousands of images.',
    cta: 'Check out my favorites',
    // colorTheme: { base: '#121212', hilite: '#df0000' },
    headerImage: randomBlomArchiveImage,
    images: blomArchiveImages,
    prevSlug: 'community-gardens',
    nextSlug: 'blom',
  },
  unionSquare: {
    title: 'Union Square',
    uid: 'unionSquare',
    slug: 'generative-art-in-new-york-union-square',
    link: '/work/generative-art-installation-in-union-square',
    cta: "I'm scared but curious",
    excerpt:
      "Eighteen million pixels and a couple terrabytes of generative content can't be wrong.",
    // colorTheme: { base: '#df1212', hilite: '#ef1212' },
    headerImage: [
      {
        srcSet: UnionSquareProject_sm,
        media: '(max-width: 720px)',
      },
      {
        srcSet: UnionSquareProject,
      },
    ],
    prevSlug: 'blom',
    nextSlug: 'lightblades',
  },
  lightblades: {
    title: 'Lightblades',
    uid: 'lightblades',
    slug: 'lightblades-installation-at-the-geode-in-portland',
    link: '/work/lightblades-installation-at-the-geode-in-portland',
    cta: 'Read More',
    excerpt:
      "Portland's newest creative space wouldn't be very creative without a 3-story tall installation.",
    // colorTheme: { base: '#ff9900', hilite: '#ff9900' },
    headerImage: randomLightbladeImage,
    headerIndex: randomLightbladeIndex,
    images: lightbladeImages,
    prevSlug: 'unionSquare',
    nextSlug: 'sketches',
  },

  intergalactic: {
    title: 'Intergalactic',
    uid: 'intergalactic',
    slug:
      'intergalactic-a-generative-art-photographic-collaboration-with-costume-maker-wendi-anderson',
    link:
      '/work/intergalactic-a-generative-art-photographic-collaboration-with-costume-maker-wendi-anderson',
    excerpt:
      'I projected generative art onto my costume maker/wife and shot the whole thing through a glass prism',
    cta: 'Check it out',
    // colorTheme: { base: '#121212', hilite: '#df0000' },
    headerImage: randomIntergalacticImage,
    images: intergalacticImages,
    prevSlug: 'lightblades',
    nextSlug: 'sketches',
  },

  sketches: {
    title: 'Sketches',
    uid: 'sketches',
    slug: 'sketches',
    link: '/work/sketches',
    cta: 'Room for improvement',
    excerpt: 'This is a collection of work that no one likes except me.',
    // colorTheme: { base: '#ff9900', hilite: '#ff9900' },
    headerImage: randomSketchImage,
    images: sketchImages,
    prevSlug: 'intergalactic',
    nextSlug: 'community-gardens',
  },
};

// forEach(work, (w, index) => {
//   const nextWork = index < work.length - 1 ? work[index + 1] : work[0];
//   const prevWork = index > 0 ? work[index - 1] : work[work.length - 1];
//   w.nextSlug = nextWork.slug;
//   w.prevSlug = prevWork.slug;
// });

const WorkModel = {};

WorkModel.fetch = () =>
  new Promise(resolve => {
    setTimeout(() => resolve(work), 20);
  });

export default WorkModel;



// WEBPACK FOOTER //
// ./src/models/work.js